import { LayoutHOC } from 'base/ui/layout/layout';
import { formSurvey } from './formSurvey';

export const createFormSurveyPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(formSurvey());
};
